import CommonApi from "./CommonApi";
import ITest from "@/interfaces/ITest";

export default class AdminApi extends CommonApi {
    private userTestsUrl = "/api/user/getUserTestsets";
    private testUrl = "/api/user/gettestsets/";
    private saveTestResultUrl = "/api/user/addResultUserTestset";

    loadAssignedTests(): Promise<any> {
        return this.getWithToken(this.userTestsUrl);
    }

    loadTest(id: number): Promise<any> {
        return this.getWithToken(`${this.testUrl}${id}`);
    }

    saveTestResult(test: ITest): Promise<any> {
        return this.postWithToken(this.saveTestResultUrl, test, "Результаты теста успешно отправлены");
    }
}